import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import EmailTemplateModal from "../../email/EmailTemplateModal";
import { useGetTemplateQuery } from "../../../Services/email/EmailTemplate";
import { useCustomerNotesMutation } from "../../../Services/ticket/Messages";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Box, Chip } from "@mui/material";
import "../../ticket/ticketListInfo/Messages.scss";
interface IPROPS {
  customerNotes: any;
  fetchingNotes: any;
  showCompose: boolean;
  setShowCompose: (show: boolean) => void;
}

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "700px",
    height: "600px",
  },
};

// Utility function to strip HTML tags (safe, DOMParser-based)
const stripHtmlTags = (html: string) => {
  const doc = new window.DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

const ExternalMessageCamapaign: React.FC<IPROPS> = ({
  customerNotes,
  fetchingNotes,
  showCompose,
  setShowCompose,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [storeTemplateData, setStoreTemplateData] = useState<any>([]);
  const [selectedTemplateDescription, setSelectedTemplateDescription] =
    useState<any>("");
  const [value, setValue] = useState<string>("");
  const [initials, setInitials] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [files, setFiles] = useState([]);
  const [templateAttachment, setTemplateAttachment] = useState<any[]>([]);

  const { data: getTemplate } = useGetTemplateQuery({
    team_id: localStorage.getItem("teamId"),
  });
  const [trigger, { isLoading }] = useCustomerNotesMutation();
  const { uuid } = useParams();

  const customerNoteSubmitHandler = async () => {
    if (!uuid) {
      toast.error("Invalid ticket ID.");
      return;
    }

    if (!value && !selectedTemplateDescription?.content) {
      toast.error("Message content cannot be empty.");
      return;
    }

    const customerNoteObj = {
      attachments: files || [],
      template_attachments:
        templateAttachment?.map((attachment) => attachment?.id) || [],
      content: stripHtmlTags(selectedTemplateDescription?.content || value),
      ticket: uuid,
    };

    try {
      await trigger(customerNoteObj).unwrap();
      fetchingNotes();
      setFiles([]);
      setTemplateAttachment([]);
      setSelectedTemplateDescription({});
      setValue("");
      setShowCompose(false);

      toast.success("Note saved successfully");
    } catch (error: any) {
  toast.error(error?.ticket?.[0] || "Failed to save note.");
  console.log(error,"errorerrorerror");
}


  };

  const handleFileChange = async (event) => {
    const newFiles = Array.from(event.target.files);
    const filePromises = newFiles.map((file: any) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const fileData = {
            file_name: file.name,
            file: e.target.result.split(",")[1], // Extracting Base64 part
          };
          resolve(fileData);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });

    try {
      const fileDataArray = await Promise.all(filePromises);
      setFiles((prevFiles) => {
        return [...prevFiles, ...fileDataArray];
      });
    } catch (error) {
      toast.error("An error occurred while uploading files. Please try again.");
    }
  };

  const handleDownloadFile = (fileId) => {
    // Implement the download logic here
    // For example, using an API call to get the file or redirect to the file URL
    window.open(`${fileId}`, "_blank");
  };
  const handleDeleteAttachmentFile = (fileToDeleteId) => async () => {
    // Directly update the local state after the API call
    setTemplateAttachment((prev) => {
      // Filter out the attachment with the matching fileToDeleteId
      const updatedAttachments = prev.filter(
        (file) => String(file.id) !== String(fileToDeleteId),
      );

      return [...updatedAttachments]; // Return a new array
    });
  };

  const handleDeleteFile = (fileToDelete) => () => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToDelete));
  };

  function formatDate(dateString: string) {
    const date = new Date(dateString);

    // Extract components
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Format the date and time
    const formattedDate = `${day}/${month}/${year}`;
    const formattedTime = `${hours}:${minutes}`;

    return `${formattedDate} ${formattedTime}`;
  }

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    // Retrieve the username from local storage
    const storedUsername = localStorage.getItem("circleone-username") || "";

    // Generate initials
    const nameParts = storedUsername.split(" ");
    const generatedInitials = nameParts
      .map((part) => part.charAt(0))
      .join("")
      .toUpperCase();

    // Set initials and username state
    setInitials(generatedInitials);
    setName(storedUsername);
  }, []);

  useEffect(() => {
    if (getTemplate) {
      setStoreTemplateData(getTemplate);
    }
  }, [getTemplate]);

  useEffect(() => {
    if (selectedTemplateDescription) {
      // Strip HTML tags from content and set value
      setValue(stripHtmlTags(selectedTemplateDescription.content));
    }
  }, [selectedTemplateDescription]);

  const getAvatarColor = (index: number) => {
    const colors = ["avatar-blue", "avatar-green", "avatar-purple"];
    return colors[index % colors.length];
  };

  return (
    <div>
      <div className={`compose-note ${showCompose ? "" : "d-none"}`}>
        <textarea
          className="compose-textarea"
          value={value}
          onChange={(e) =>
            setSelectedTemplateDescription({
              ...selectedTemplateDescription,
              content: e.target.value,
            })
          }
          rows={3}
          placeholder="Type your message here..."
        />

        {files.length > 0 && (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
            {files.map((file, index) => (
              <Chip
                key={index}
                label={file.file_name}
                onDelete={handleDeleteFile(file)}
              />
            ))}
          </Box>
        )}

        <div className="compose-footer">
          <div className="compose-actions">
            <label
              htmlFor="attachFileInput"
              className={`action-btn ${value ? "" : "disabled"}`}
              title="You can add attachments for the following 
           file types: xls,pdf,csv,doc,jpg,png up to a maximum size of 15MB"
            >
              <i className="bi bi-paperclip"></i>
              <input
                type="file"
                id="attachFileInput"
                className="d-none"
                multiple
                onChange={handleFileChange}
                disabled={!value}
              />
            </label>
          </div>

          <button
            type="submit"
            className="btn btn-sm btn-primary"
            onClick={customerNoteSubmitHandler}
          >
            {isLoading ? "Sending..." : "Send"}
          </button>
        </div>
      </div>

      <div className="notes-list">
        {customerNotes?.map((el: any, index: number) => (
          <div className="note-item" key={el.id}>
            <div className="note-avatar">
              <div className={`avatar-circle ${getAvatarColor(index)}`}>
                {initials}
              </div>
            </div>

            <div className="note-content">
              <div className="note-header">
                <div className="note-author">
                  <span className="author-name">{name.split("@")[0]}</span>
                  <span className="note-dot"></span>
                  <span className="note-timestamp">
                    {el?.created_by?.created
                      ? formatDate(el.created)
                      : "Date not available"}
                  </span>
                </div>
              </div>

              <p className="note-text">{stripHtmlTags(el?.content)}</p>

              {el.attachments?.length > 0 && (
                <div className="note-attachments">
                  {el.attachments.map((attachment, idx) => (
                    <div
                      key={attachment.id}
                      className="attachment-chip"
                      onClick={() => handleDownloadFile(attachment.file)}
                    >
                      <i className="bi bi-paperclip attachment-icon"></i>
                      <span>
                        {attachment.file_name || `Attachment ${idx + 1}`}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Email templates"
        shouldCloseOnOverlayClick={false}
      >
        <EmailTemplateModal
          closeModal={closeModal}
          setSelectedTemplateDescription={setSelectedTemplateDescription}
          storeTemplateData={storeTemplateData}
          setTemplateAttachment={setTemplateAttachment}
        />
      </ReactModal>
    </div>
  );
};

export default ExternalMessageCamapaign;